import React from 'react';
import '../FormControl/FormControl.es.js';
import { useFormControl } from '../FormControl/FormControlContext.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';
import { omitSystemProps, getSystemProps } from '../../system/styled-system.es.js';
import '../../utils/assertions.es.js';
import { warn } from '../../utils/functions.es.js';
import { mergeRefs } from '../../utils/refs.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Wrapper, Input as Input$1 } from './styled.es.js';
import { InputAddon } from './InputAddon.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Input = forwardRef((props, ref) => {
  const _a = omitSystemProps(props), {
    className,
    shape = "default",
    size = "md",
    variant = "outlined",
    isInvalid,
    isValid,
    isRequired,
    isDisabled,
    isReadOnly,
    type = "text",
    autoComplete = "off",
    addonLeft,
    addonRight,
    value,
    wrapperRef: wrapperRefProp = null,
    wrapperProps,
    defaultValue,
    isMultiline,
    inputRef: inputRefProp = null
  } = _a, rest = __objRest(_a, [
    "className",
    "shape",
    "size",
    "variant",
    "isInvalid",
    "isValid",
    "isRequired",
    "isDisabled",
    "isReadOnly",
    "type",
    "autoComplete",
    "addonLeft",
    "addonRight",
    "value",
    "wrapperRef",
    "wrapperProps",
    "defaultValue",
    "isMultiline",
    "inputRef"
  ]);
  const _b = getSystemProps(props), systemProps = __objRest(_b, ["color"]);
  const formControl = useFormControl({
    isInvalid,
    isValid,
    isRequired,
    isDisabled,
    isReadOnly
  });
  warn({
    condition: !!inputRefProp,
    message: "The inputRef prop is deprecated and will be removed in v1, use ref directly"
  });
  const inputRef = mergeRefs(inputRefProp, ref);
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadValues(__spreadValues({
    className,
    ref: wrapperRefProp,
    size,
    shape,
    variant,
    isDisabled: formControl.isDisabled,
    isInvalid: formControl.isInvalid,
    isValid: formControl.isValid,
    isRequired: formControl.isRequired,
    isReadOnly: formControl.isReadOnly,
    isMultiline
  }, systemProps), wrapperProps), !!React.Children.count(addonLeft) && React.Children.map(addonLeft, (addon) => isMultiline ? addon : /* @__PURE__ */ React.createElement(InputAddon, {
    placement: "left"
  }, addon)), /* @__PURE__ */ React.createElement(Input$1, __spreadValues({
    ref: inputRef,
    type,
    value,
    autoComplete,
    variant,
    isDisabled: formControl.isDisabled,
    disabled: formControl.isDisabled,
    readOnly: formControl.isReadOnly,
    required: formControl.isRequired,
    "data-invalid": formControl.isInvalid,
    defaultValue,
    isMultiline,
    size
  }, rest)), !!React.Children.count(addonRight) && React.Children.map(addonRight, (addon) => isMultiline ? addon : /* @__PURE__ */ React.createElement(InputAddon, {
    placement: "right"
  }, addon)));
});
Input.displayName = "Input";

export { Input };
//# sourceMappingURL=Input.es.js.map
